import { useMemo } from "react";

import type { HotelTopQuery } from "@/lib/gql/__generated__/graphql";

import { START_GUIDE_HOTEL_INFO_ID, START_GUIDE_HOTEL_POLICY_ID } from "../../constants";
import { useHighlight } from "../_shared/use-highlight";

type StartGuide = HotelTopQuery["startGuide"];

export const useStartGuideHighlightStep1 = (startGuide: StartGuide) => {
	const target = useMemo(() => {
		// 施設の基本情報が登録されていない場合は施設の基本情報をハイライト設定
		if (!startGuide.isHotelInfoRegistered) {
			return {
				element: `#${START_GUIDE_HOTEL_INFO_ID}`,
				title: "まずは施設の基本情報から",
				description: "施設名・住所・連絡先などの基本情報を登録してください",
			};
		}
		// 施設のポリシーが登録されていない場合は施設のポリシーをハイライト設定
		if (!startGuide.isHotelPolicyRegistered) {
			return {
				element: `#${START_GUIDE_HOTEL_POLICY_ID}`,
				title: "施設のポリシーを設定",
				description:
					"チェックイン・チェックアウト時間やキャンセルポリシーなど、施設の運用ルールを登録してください",
			};
		}
		return null;
	}, [startGuide.isHotelInfoRegistered, startGuide.isHotelPolicyRegistered]);

	// ハイライト実行
	useHighlight(target);
};
